import DashboardInboundBacklog  from './dashboard-inbound-backlog';
import DashboardOutboundBacklog  from './dashboard-outbound-backlog';
import DashboardEmpStatBacklog from './dashboard-empstat-backlog';
import DashboardWorkOrderStatBacklog from './dashboard-workorder-stat-backlog';
import DashboardSoAgingBacklog from './dashboard-soaging-backlog';
import DashboardSoProcessBacklog from './dashboard-soprocess-backlog'
import DashboardEmpStatByWorkOrderBacklog from './dashboard-empstat-workorder-backlog';

export default class DashboardInfo {
    inbound:Array<DashboardInboundBacklog>;
    outbound : Array<DashboardOutboundBacklog>;
    empStats : Array<DashboardEmpStatBacklog>;
    workOrderStats : Array<DashboardWorkOrderStatBacklog>;
    soAgings: Array<DashboardSoAgingBacklog>;
    soProcesses : Array<DashboardSoProcessBacklog>;
    empWorkOrderStats :Array<DashboardEmpStatByWorkOrderBacklog>;
}